import { Component, OnInit, inject } from '@angular/core'
import { Router } from '@angular/router'
import { ICuenta } from 'src/app/core/modules/sistema/models/cuenta/ICuenta.interface'
import { CuentaService } from 'src/app/core/modules/sistema/services/cuenta.service'
import { SeguridadService } from 'src/app/core/modules/sistema/services/seguridad/seguridad.service'
import { SpinnerService } from 'src/app/core/services/spinner.service'
import Swal from 'sweetalert2'

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  standalone: false,
  styleUrls: ['./inicio.component.css'],
})
export class InicioComponent implements OnInit {
  private _router = inject(Router)
  private _spinnerService = inject(SpinnerService)
  private _seguridadService = inject(SeguridadService)
  private _cuentaService = inject(CuentaService)

  public cuentas: Array<ICuenta> = []
  public cuentaSeleccionada: ICuenta | undefined

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[])

  constructor() {}

  ngOnInit(): void {
    this._spinnerService.show()

    this._cuentaService.GetAll().subscribe({
      next: (data) => {
        this.cuentas = data['result'] as Array<ICuenta>

        let cuentaId = this._seguridadService.obtenerCuenta()
        if (!!cuentaId) {
          this.cuentaSeleccionada = this.cuentas.find((e) => e.id == cuentaId)
        } else {
          this.cuentaSeleccionada = this.cuentas[0]
        }
      },
      error: (error) => {
        Swal.fire({
          icon: 'error',
          title: 'Lo sentimos',
          text: error.responseException.exceptionMessage,
          confirmButtonText: 'Cerrar',
        })
      },
      complete: () => {
        this._spinnerService.hide()
      },
    })
  }

  public asignarCuenta(): void {
    if (!this.cuentaSeleccionada) return

    this._seguridadService.asignarCuenta(this.cuentaSeleccionada)
    this._router.navigate(['dashboard'])
  }
}
